import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const UtmGenerator = () => {
  const navigate = useNavigate();
  
  // Estado para os campos do formulário
  const [formData, setFormData] = useState({
    urlBase: 'https://fitloja.com.br/off-fit-loja.html',
    data: new Date().toISOString().split('T')[0], // Data atual formato YYYY-MM-DD
    source: 'whatsapp',
    medium: 'messaging',
    campaign: 'verão',
    content: 'banner',
    term: 'segmentado'
  });

  const [urlFinal, setUrlFinal] = useState('Preencha os dados acima...');
  const [copiado, setCopiado] = useState(false);

  // Lógica de tratamento de texto (limpeza de caracteres)
  const tratarTexto = (t) => {
    return t.normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "") // Remove acentos
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')           // Espaço vira hífen
            .replace(/[^a-z0-9\-]/g, '');   // Remove caracteres especiais
  };

  const gerarLink = () => {
    if (!formData.urlBase) return alert("Insira a URL de destino.");

    const campanhaLimpa = tratarTexto(formData.campaign);
    const campanhaFinal = `${formData.data}-${campanhaLimpa}`;

    try {
      const url = new URL(formData.urlBase);
      url.searchParams.set('utm_source', formData.source);
      url.searchParams.set('utm_medium', formData.medium);
      url.searchParams.set('utm_campaign', campanhaFinal);
      url.searchParams.set('utm_content', formData.content);
      url.searchParams.set('utm_term', formData.term);

      setUrlFinal(url.toString());
      setCopiado(false);
    } catch (e) {
      alert("URL inválida.");
    }
  };

  const copiarLink = () => {
    navigator.clipboard.writeText(urlFinal).then(() => {
      setCopiado(true);
      setTimeout(() => setCopiado(false), 2000);
    });
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.headerRow}>
            <button onClick={() => navigate('/lojas')} style={styles.backBtn}>← Voltar</button>
            <h2 style={styles.title}>Gerador de Links UTM</h2>
        </div>
        
        <div style={styles.grid}>
          <div style={styles.full}>
            <label style={styles.label}>URL de Destino</label>
            <input 
              style={styles.input} 
              type="text" 
              value={formData.urlBase}
              onChange={(e) => setFormData({...formData, urlBase: e.target.value})}
            />
          </div>
          
          <div>
            <label style={styles.label}>Data</label>
            <input 
              style={styles.input} 
              type="date" 
              value={formData.data}
              onChange={(e) => setFormData({...formData, data: e.target.value})}
            />
          </div>

          <div>
            <label style={styles.label}>utm_source</label>
            <select style={styles.select} value={formData.source} onChange={(e) => setFormData({...formData, source: e.target.value})}>
              <option value="whatsapp">whatsapp</option>
              <option value="meta">meta</option>
              <option value="google">google</option>
              <option value="email">email</option>
              <option value="sms">sms</option>
            </select>
          </div>

          <div>
            <label style={styles.label}>utm_medium</label>
            <select style={styles.select} value={formData.medium} onChange={(e) => setFormData({...formData, medium: e.target.value})}>
              <option value="messaging">messaging</option>
              <option value="paid_search">paid_search</option>
              <option value="paid_social">paid_social</option>
              <option value="display">display</option>
              <option value="email">email</option>
            </select>
          </div>

          <div>
            <label style={styles.label}>utm_campaign (Nome)</label>
            <input 
              style={styles.input} 
              type="text" 
              value={formData.campaign}
              onChange={(e) => setFormData({...formData, campaign: e.target.value})}
            />
          </div>

          <div>
            <label style={styles.label}>utm_content (Conteúdo)</label>
            <select style={styles.select} value={formData.content} onChange={(e) => setFormData({...formData, content: e.target.value})}>
              <option value="carrossel">carrossel</option>
              <option value="video">video</option>
              <option value="imagem">imagem</option>
              <option value="feed">feed</option>
              <option value="texto">texto</option>
              <option value="produto">produto</option>
              <option value="banner">banner</option>
              <option value="newsletter">newsletter</option>
              <option value="pdf">pdf</option>
            </select>
          </div>

          <div>
            <label style={styles.label}>utm_term (Termo)</label>
            <select style={styles.select} value={formData.term} onChange={(e) => setFormData({...formData, term: e.target.value})}>
              <option value="segmentado">segmentado</option>
              <option value="advantage">advantage</option>
              <option value="remarketing">remarketing</option>
              <option value="search">search</option>
              <option value="shopping">shopping</option>
              <option value="pmax">pmax</option>
              <option value="display">display</option>
              <option value="base-geral">base-geral</option>
            </select>
          </div>
        </div>

        <button style={styles.btnGenerate} onClick={gerarLink}>GERAR LINK TAGUEADO</button>

        <div style={styles.resultSection}>
          <label style={styles.label}>URL Final Gerada:</label>
          <span style={styles.urlFinal}>{urlFinal}</span>
          {urlFinal.startsWith('http') && (
            <button style={styles.btnCopy} onClick={copiarLink}>
              {copiado ? "COPIADO!" : "COPIAR LINK"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

// Estilização baseada no seu CSS original, adaptada para React
const styles = {
  container: { backgroundColor: '#f8fafc', minHeight: '100vh', padding: '40px 20px', fontFamily: 'Inter, sans-serif' },
  card: { maxWidth: '700px', margin: '0 auto', background: 'white', padding: '32px', borderRadius: '16px', boxShadow: '0 10px 25px rgba(0,0,0,0.05)' },
  headerRow: { display: 'flex', alignItems: 'center', gap: '20px', borderBottom: '2px solid #f1f5f9', marginBottom: '24px', paddingBottom: '16px' },
  backBtn: { padding: '5px 12px', cursor: 'pointer', borderRadius: '6px', border: '1px solid #cbd5e1', backgroundColor: '#fff' },
  title: { margin: 0, fontSize: '1.5rem', color: '#1e293b' },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' },
  full: { gridColumn: 'span 2' },
  label: { display: 'block', fontSize: '0.75rem', fontWeight: '700', textTransform: 'uppercase', color: '#64748b', marginBottom: '6px' },
  input: { width: '100%', padding: '12px', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '1rem', boxSizing: 'border-box' },
  select: { width: '100%', padding: '12px', border: '1px solid #cbd5e1', borderRadius: '8px', fontSize: '1rem', background: '#fff' },
  btnGenerate: { background: '#2563eb', color: 'white', cursor: 'pointer', border: 'none', borderRadius: '8px', fontWeight: '600', fontSize: '1rem', width: '100%', padding: '14px', marginTop: '24px' },
  resultSection: { marginTop: '32px', padding: '24px', background: '#f1f5f9', borderRadius: '12px' },
  urlFinal: { display: 'block', fontFamily: 'monospace', wordBreak: 'break-all', marginBottom: '20px', color: '#2563eb', fontSize: '0.95rem', lineHeight: '1.5' },
  btnCopy: { background: '#10b981', color: 'white', cursor: 'pointer', border: 'none', borderRadius: '8px', fontWeight: '600', fontSize: '1rem', width: '100%', padding: '14px' },
};

export default UtmGenerator;